var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "vue-content-loading",
    { attrs: { width: 300, height: _vm.lines * 14 } },
    [
      _vm._l(_vm.lines, function (_, index) {
        return [
          !_vm.hideCircle
            ? _c("circle", { attrs: { cy: 6 + index * 14, cx: "6", r: "6" } })
            : _vm._e(),
          _vm._v(" "),
          _c("rect", {
            attrs: {
              x: _vm.hideCircle ? 0 : 18,
              y: 1 + index * 14,
              rx: "4",
              ry: "4",
              width: "350",
              height: "10",
            },
          }),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }